





















































import { Component, Vue, Prop } from "vue-property-decorator";
import WsResponseModel from "../../dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import UserResponse from "../../dataSource/api/RunPay/Admin/IServices/Models/Accounts/UserResponse";
import { set } from "js-cookie";
import ListViewItem from "list-view/src/listviewitem";
import DefaultModel from "../a-model/default-model";

// import WsResponseModel from "../../../dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
// import BaseResponse from "../../../dataSource/api/Common/ResponseModels/BaseResponse";
// import UserResponse from "../../../dataSource/api/Users/IdentityService/Models/UserResponse";

// import DictionaryModel from "@dataSource/Models/DictionaryModel";
// import LayoutComponent from "@layouts/layout.vue";

@Component({
  name: "page-login"

  // components: {
  //   layout: LayoutComponent
  // }
})
export default class LoginComponent extends Vue {
  constructor() {
    super();
  }

  login = "";
  password = "";
  errorMessage: String = null;
  langItems: ListViewItem<DefaultModel>[] = [];

  created() {
    this.getLangItems();
  }

  getLangItems() {
    this.langItems.push(new ListViewItem(new DefaultModel(0, "English"), true, false));
    this.langItems.push(new ListViewItem(new DefaultModel(1, "Русский"), false, false));
    this.langItems.push(new ListViewItem(new DefaultModel(2, "Français"), false, false));
    const currentLang = this.$locale.currentLang || "";
    switch (currentLang) {
      case "en":
        this.langItems.forEach(item => {
          item.Selected = item.Value.id == 0;
        });
        break;
      case "ru":
        this.langItems.forEach(item => {
          item.Selected = item.Value.id == 1;
        });
        break;
      case "fr":
        this.langItems.forEach(item => {
          item.Selected = item.Value.id == 2;
        });
        break;
      case "de":
        this.langItems.forEach(item => {
          item.Selected = item.Value.id == 3;
        });
        break;
      default:
        this.langItems.forEach(item => {
          item.Selected = item.Value.id == 0;
        });
        break;
    }
  }

  onClick() {
    this.$api.AccountService.LoginEvent.once(response => {
      if (response.IsSuccess) {
        // this.$api.AccountWsService.Activate(response.Value);
        this.$api.SetUser({
          Id: parseInt(response.Value.Id.toString()),
          Email: response.Value.Email,
          FullName: response.Value.FullName
        });
        set("Auth-Token", response.Value.SessionToken);

        if (response.Value != null) this.$router.push("/" + this.$locale.currentLang);
      }
      this.errorMessage = response.ErrorMessage;
    });

    this.errorMessage = null;
    this.$locale.currentLang = this.getSelectedLang();
    this.$api.AccountService.Login({ Email: this.login, Password: this.password });
  }

  getSelectedLang(): string {
    const langIndex = this.langItems.filter(item => item.Selected)[0].Value.id;
    switch (langIndex) {
      case 0:
        return "en";
        break;
      case 1:
        return "ru";
        break;
      case 2:
        return "fr";
        break;
      default:
        return "en";
        break;
    }
  }
  onChangeLocale(resp: ListViewItem<DefaultModel>[]) {
    let val = "";
    switch (resp[0].Value.id) {
      case 0:
        val = "en";
        break;
      case 1:
        val = "ru";
        break;
      case 2:
        val = "fr";
        break;
      case 3:
        val = "de";
        break;
      default:
        break;
    }
    this.$router.replace({ name: this.$route.name, params: Object.assign(this.$route.params, { lang: val }), query: this.$route.query });
    location.reload();
  }
  test(): string {
    return this.$locale.getTranslate("login");
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/account/login.vue